export const lift = observer => {
  if (typeof observer === 'function') {
    return {
      next: observer
    };
  }
  return observer;
};